import { Box, Divider } from "@mui/material";
import BookmarkPlan from "components/common/Bookmark";
import BasicTable from "components/common/Table";
import { uniq } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { abovePropertyViewTypePlan, noAbovePropertyPlans, PAGE_SIZE, tabConstants } from "utils/CommonConstants";
import {
  functionalAreaIdsToNames,
  getHltInncodes,
  getSourceName,
  isAboveUserPlanBookmarked
} from "utils/CommonFunctions";
import { routes } from "utils/routes";
import { fetchAssignedLibraryPlansAsync } from "../../AboveProperty.slice";
import FilterButtons from "../../FilterButtons";
import { headers } from "./TableHeadersConfig";

const AssignedLibraryPlans = () => {
  const [pageNo, setPageNo] = useState(0);
  const [assignedPlanData, setAssignedPlanData] = useState([]);
  const dispatch: any = useAppDispatch();
  const navigate = useNavigate();
  const assignedLibraryPlan = useAppSelector((state) => state.aboveProperty.assignedLibraryPlan);
  const totalRecords = useAppSelector((state) => state.aboveProperty.totalRecords);
  const bookmarkedIdList = useAppSelector((state) => state.aboveProperty.bookmarkedIdList);
  const { functionalAreas, source, searchText } = useAppSelector(
    (state: any) => state.aboveProperty.filters.planViewFilters.assignedPlanFilters
  );

  useEffect(() => {
    if (assignedLibraryPlan?.length) {
      const rowData = assignedLibraryPlan?.map((item: any) => {
        return {
          data: [
            {
              content: (
                <Box
                  onClick={() =>
                    navigate(`${routes.PlanProgress}/${item?.cmsId}?redirectFrom=${tabConstants.libraryPlans}`, {
                      state: { progressInncodes: item?.properties }
                    })
                  }
                  sx={{
                    textDecoration: "none",
                    cursor: "pointer",
                    color: tokens.Text.General.PrimaryHeadline,
                    fontWeight: "700"
                  }}
                >
                  {item?.name}
                </Box>
              )
            },
            { content: functionalAreaIdsToNames(item?.functionalAreaIds).join(", ") },
            { content: uniq(item?.sources?.map((src: any) => getSourceName(src))).join(", ") },
            { content: item?.propertiesCount },
            {
              content: (
                <BookmarkPlan
                  aboveUserPayload={{
                    isAboveUsertype: true,
                    viewType: abovePropertyViewTypePlan
                  }}
                  cmsId={item?.cmsId}
                  isBookmarked={isAboveUserPlanBookmarked(item?.cmsId, "bookmarkedIdList")}
                />
              )
            }
          ]
        };
      });
      setAssignedPlanData(rowData);
    } else setAssignedPlanData([]);
  }, [assignedLibraryPlan, bookmarkedIdList]);

  useEffect(() => {
    dispatch(
      fetchAssignedLibraryPlansAsync({
        innCodes: getHltInncodes(),
        functionalAreaIds: functionalAreas,
        sources: source,
        searchText: searchText,
        pageable: {
          page: pageNo,
          size: PAGE_SIZE
        }
      })
    );
  }, [pageNo, source, functionalAreas, searchText]);

  useEffect(() => {
    setPageNo(0);
  }, [functionalAreas, source, searchText]);

  return (
    <Box
      sx={{
        backgroundColor: tokens.Background.General.Primary,
        borderRadius: "12px"
      }}
    >
      <FilterButtons searchPredefinedValue={searchText} isFunctionalAreaVisible isSearchBarVisible isSourceVisible />
      <Divider />
      <BasicTable
        data={{
          headers,
          rows: assignedPlanData
        }}
        totalRecords={totalRecords}
        noDataMessage={noAbovePropertyPlans}
        pagination={{ pageNo: pageNo, setPageNo: setPageNo }}
      />
    </Box>
  );
};

export default AssignedLibraryPlans;
